module.exports = __webpack_public_path__ + "static/media/modbus-part.e8800f52.png";